package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface AddNewTrainingScreen3PageProps : Props {
    var viewModel: AddNewTrainingViewModel
    var onNextButtonClicked: () -> Unit
}

private data class AgeGroupContent(val key: AgeGroupKey, val title: String)

private val ageGroupContents = listOf(
    AgeGroupContent(AgeGroupKey.UNDER_30, "Under 30"),
    AgeGroupContent(AgeGroupKey.AGE_30_39, "30 - 39"),
    AgeGroupContent(AgeGroupKey.AGE_40_49, "40 - 49"),
    AgeGroupContent(AgeGroupKey.AGE_50_64, "50 - 64"),
    AgeGroupContent(AgeGroupKey.OVER_65, "65 +"),
)

// Pixel-matched against AddNewTrainingScreen3.kt: same row chrome and auto-advance-on-click
// behavior as Screen 2, but AgeGroup has no image/description (unlike Goal/Level) — AddTrainingRow
// already handles that nullable case (centered, SemiBold-equivalent title, no info dialog).
internal val AddNewTrainingScreen3Page = FC<AddNewTrainingScreen3PageProps> { props ->
    var selectedAgeGroup by useState(props.viewModel.selectedAgeGroup.value)

    useEffectOnce {
        scope.launch { props.viewModel.selectedAgeGroup.collect { selectedAgeGroup = it } }
    }

    div {
        className = ClassName("wizard-page")

        StepProgressIndicator(3, listOf(CenterFocusStrongIcon, TrendingUpIcon, PersonIcon, CalendarMonthIcon))

        PageTitleSection(
            "Select your age group",
            "Your age group helps us design a yoga program tailored to your physical needs, ensuring safe and effective practice."
        )

        div {
            className = ClassName("wizard-list")
            ageGroupContents.forEach { content ->
                AddTrainingRow(null, content.title, null, selectedAgeGroup == content.key) {
                    props.viewModel.selectAgeGroup(content.key)
                    props.onNextButtonClicked()
                }
            }
        }
    }
}
